// CX 답변 멱등 키 + 자동 이메일 상태 표시 (2026-09-28).
//
// replyId 는 "답변 1건"의 멱등 키다. 관리자가 네트워크 오류로 재시도할 때 같은 키를 보내야
// 서버가 중복 저장·중복 이메일을 막을 수 있다(서버 생성 타임스탬프로는 재시도를 구분 못 함).
// 규칙: 새 답변을 보낼 때 1회 생성 → 실패하면 유지(같은 키로 재시도) → 성공하면 버린다.

export function newReplyId() {
  try {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
      return crypto.randomUUID();
    }
  } catch { /* 구형 브라우저 폴백 */ }
  return `r-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

// 서버가 허용하는 문자만(백엔드 _norm_reply_id 와 동일 규칙) — 경로 안전성.
export function isValidReplyId(id) {
  return typeof id === "string" && id.length > 0 && id.length <= 64 && /^[A-Za-z0-9_-]+$/.test(id);
}

// ── 자동 이메일 상태 → 관리자 UI 표시 ────────────────────────────────────────
// 티켓의 replyNotify 맵에서 "가장 최근 답변"의 상태를 고른다. sentAt/errorAt/reservedAt 중
// 가장 늦은 시각을 기준으로 삼는다(맵은 순서를 보장하지 않으므로).
export function latestNotify(replyNotify) {
  const entries = Object.entries(replyNotify || {});
  if (entries.length === 0) return null;
  const ts = (v) => v?.sentAt || v?.errorAt || v?.reservedAt || "";
  entries.sort((a, b) => String(ts(a[1])).localeCompare(String(ts(b[1]))));
  const [replyId, state] = entries[entries.length - 1];
  return { replyId, ...(state || {}) };
}

// 수동 버튼 라벨 — 자동 발송 성공 후에만 "재발송".
export function manualEmailLabel(notify) {
  // 자동이든 수동이든 한 번 나간 뒤에는 "재발송"이 정확한 표현.
  return (notify?.status === "sent" || notify?.manualSentAt) ? "이메일 재발송" : "이메일 발송";
}

// 상태 배지 — 운영자가 "다시 보내야 하나?"를 바로 판단할 수 있게.
// tone: ok(자동 발송됨) / error(실패) / muted(해당 없음·비활성)
export function emailStatusBadge(notify) {
  const s = notify?.status;
  // 수동 복구가 기록돼 있으면 그것을 먼저 보여준다 — 자동 실패 배지가 영구히 남으면
  // 운영자가 이미 복구했는지 알 수 없다(2026-09-28).
  if (notify?.manualSentAt) {
    return { tone: "ok", text: `수동 발송됨 · ${fmtTime(notify.manualSentAt)}` };
  }
  if (s === "sent") return { tone: "ok", text: `자동 발송됨 · ${fmtTime(notify.sentAt)}` };
  if (s === "error") return { tone: "error", text: "자동 발송 실패" };
  if (s === "pending") return { tone: "error", text: "자동 발송 확인 필요" };
  if (s === "skipped") return { tone: "muted", text: "이메일 주소 없음" };
  if (s === "disabled") return { tone: "muted", text: "자동 발송 비활성" };
  return null;
}

function fmtTime(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    const kst = new Date(d.getTime() + 9 * 60 * 60 * 1000);
    const p = (n) => String(n).padStart(2, "0");
    return `${p(kst.getUTCMonth() + 1)}/${p(kst.getUTCDate())} ${p(kst.getUTCHours())}:${p(kst.getUTCMinutes())}`;
  } catch { return ""; }
}
